"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var suggestedSearch_1 = __importDefault(require("./suggestedSearch"));
exports.default = (function () {
    var searchInputs = Array.from(document.querySelectorAll('input[data-suggested-search]'));
    searchInputs.forEach(function (element) {
        var endpointString = element.dataset.suggestedSearch;
        var endpoint = '';
        switch (endpointString) {
            case 'advisors':
                endpoint = '/wp-json/wp/v2/advisors';
                break;
            case 'firms':
                endpoint = '/wp-json/wp/v2/firms';
                break;
        }
        suggestedSearch_1.default({
            element: element,
            endpoint: endpoint,
            itemTemplate: function (item) { return ("<li class=\"SuggestedSearch__item\">\n          <a href=\"" + item.link + "\">\n            " + (item.thumbnail.url ? "<img src=\"" + item.thumbnail.url + "\" alt=\"" + item.title.rendered + "\" />" : '') + "\n            " + item.title.rendered + "\n          </a>\n        </li>"); }
        });
    });
});
